import { Cell, Color, Piece } from './types';

function s(coords: [number, number][]): Cell[] {
  return coords.map(([r, c]) => ({ r, c }));
}

const SHAPES: Cell[][] = [
  // 1×1
  s([[0,0]]),
  // 1×2 / 2×1
  s([[0,0],[0,1]]),
  s([[0,0],[1,0]]),
  // 1×3 / 3×1
  s([[0,0],[0,1],[0,2]]),
  s([[0,0],[1,0],[2,0]]),
  // Corners (2×2 minus one)
  s([[0,0],[0,1],[1,0]]),
  s([[0,0],[0,1],[1,1]]),
  s([[0,0],[1,0],[1,1]]),
  s([[0,1],[1,0],[1,1]]),
  // 2×2
  s([[0,0],[0,1],[1,0],[1,1]]),
  // 1×4 / 4×1
  s([[0,0],[0,1],[0,2],[0,3]]),
  s([[0,0],[1,0],[2,0],[3,0]]),
  // L-shapes (4 rotations)
  s([[0,0],[1,0],[2,0],[2,1]]),
  s([[0,1],[1,1],[2,0],[2,1]]),
  s([[0,0],[0,1],[1,0],[2,0]]),
  s([[0,0],[0,1],[1,1],[2,1]]),
  s([[0,0],[0,1],[0,2],[1,0]]),
  s([[0,0],[0,1],[0,2],[1,2]]),
  s([[0,0],[1,0],[1,1],[1,2]]),
  s([[0,2],[1,0],[1,1],[1,2]]),
  // T-shapes (4 rotations)
  s([[0,0],[0,1],[0,2],[1,1]]),
  s([[0,1],[1,0],[1,1],[1,2]]),
  s([[0,0],[1,0],[1,1],[2,0]]),
  s([[0,1],[1,0],[1,1],[2,1]]),
  // 1×5 / 5×1
  s([[0,0],[0,1],[0,2],[0,3],[0,4]]),
  s([[0,0],[1,0],[2,0],[3,0],[4,0]]),
  // 3×3
  s([[0,0],[0,1],[0,2],[1,0],[1,1],[1,2],[2,0],[2,1],[2,2]]),
  // 2×3 / 3×2
  s([[0,0],[0,1],[1,0],[1,1],[2,0],[2,1]]),
  s([[0,0],[0,1],[0,2],[1,0],[1,1],[1,2]]),
];

function getBounds(cells: Cell[]): { rows: number; cols: number } {
  return {
    rows: Math.max(...cells.map(c => c.r)) + 1,
    cols: Math.max(...cells.map(c => c.c)) + 1,
  };
}

const COLORS: Color[] = ['red', 'orange', 'yellow', 'green', 'blue', 'purple', 'cyan'];

export function randomPiece(): Piece {
  const cells = SHAPES[Math.floor(Math.random() * SHAPES.length)];
  const color  = COLORS[Math.floor(Math.random() * COLORS.length)];
  const { rows, cols } = getBounds(cells);
  return { cells, color, rows, cols };
}

export function generateTray(): [Piece, Piece, Piece] {
  return [randomPiece(), randomPiece(), randomPiece()];
}
